import type { Spec } from '@json-render/react';
import {
  ActionProvider,
  Renderer as JsonRenderer,
  StateProvider,
  VisibilityProvider
} from '@json-render/react';
import { registry } from '../registry';

function ArtifactRenderer({ spec }: { spec: Spec }) {
  return (
    <StateProvider initialState={{}}>
      <VisibilityProvider>
        <ActionProvider handlers={{}}>
          <JsonRenderer registry={registry} spec={spec} />
        </ActionProvider>
      </VisibilityProvider>
    </StateProvider>
  );
}

export default ArtifactRenderer;
